import React from 'react';

import { PanelPadding, StyledPanel } from './styles';

export type { PanelPadding } from './styles';

/**
 * Panel — superfície branca arredondada (o "card branco") que agrupa o
 * conteúdo de uma seção. Genérico e "burro": só estrutura visual, sem regra de
 * negócio. Use para envolver, por exemplo, uma etapa do fluxo de abastecimento.
 *
 * @example
 * <Panel>
 *   <SearchBar ... />
 *   <div role="group">{cards}</div>
 * </Panel>
 */
export type PanelProps = React.HTMLAttributes<HTMLDivElement> & {
  /** Espaçamento interno @default 'md' */
  padding?: PanelPadding;
  /** Adiciona borda 1px @default false */
  bordered?: boolean;
  /** Sombra de elevação. Desligue para um card "chapado" (só borda) @default true */
  shadow?: boolean;
  children: React.ReactNode;
};

export const Panel = ({
  padding = 'md',
  bordered = false,
  shadow = true,
  children,
  ...rest
}: PanelProps): React.ReactElement => {
  return (
    <StyledPanel
      $padding={padding}
      $bordered={bordered}
      $shadow={shadow}
      {...rest}
    >
      {children}
    </StyledPanel>
  );
};

export default Panel;
